import get from "lodash/get";
import React, { Component } from "react";
import { withSnackbar } from "notistack";
import { Redirect, Route, Switch, withRouter } from "react-router-dom";
import { IntlProvider } from "react-intl";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import PermissionDeniedComp from "Component/PermissionDeniedComp/PermissionDeniedComp";
import Helmet from "react-helmet";
import { instance } from "../../../../../../Actions/AxiosInstance";
import {
  CreateComp,
  List,
  TDTypeConsts,
} from "../../../../business-configration/commons";
import headersList from "../../../../../../Constants/headersList";
import { CheckActionPermission } from "../../../../../../Actions/commonAction";
import Create from "./create";
import { backToHome } from "../../../../../../Handlers/setters";
import { ErrorMessages } from "../../../../../../Constants";
import emptylist from "../../../../../../Assets/Svg/exitpolicyblank.svg";

class ExitPolicy extends Component {
  constructor(props) {
    super(props);
    this.state = {
      permissions: { editable: false, readonly: false },
      listdata: [],
      datareceived: false,
      headers: [
        {
          key: "policyname",
          name: "Name",
          type: TDTypeConsts.DEPARTMENT_NAME,
          style: { textAlign: "left" },
        },
        {
          key: "addedbyimagepath",
          name: "Create By",
          type: TDTypeConsts.CREATED_BY,
          // style: { textAlign: "left" }
        },
        {
          key: "noticeperioddays",
          name: "Notice Period",
          type: TDTypeConsts.OTHERS,
          // style: { textAlign: "left" }
        },
        {
          key: "assignedemployeelist",
          name: "Assigned Employees",
          type: TDTypeConsts.ASSIGNED_USER,
          // style: { textAlign: "left" }
        },
        { key: "edit", name: "", type: TDTypeConsts.EDIT_WITHOUT_HEADER },
        { key: "delete", name: "", type: TDTypeConsts.DELETE_WITHOUT_HEADER },
      ],
    };
    this.onEdit = this.onEdit.bind(this);
    this.getExitPolicies = this.getExitPolicies.bind(this);
    this._renderList = this._renderList.bind(this);
    this._renderCreate = this._renderCreate.bind(this);
    this._renderEdit = this._renderEdit.bind(this);
    this._onCreate = this._onCreate.bind(this);
    this.onDelete = this.onDelete.bind(this);
  }

  componentDidMount() {
    const [isTrue, permissions] = CheckActionPermission("exitPolicy");
    if (isTrue) {
      this.setState({ permissions }, () => {
        this.getExitPolicies();
        if (
          this.props.history.location.pathname.includes("create") ||
          this.props.history.location.pathname.includes("edit")
        ) {
          this.props.history.push(`${this.props.match.path}`);
        }
        if (!this.state.permissions.editable) {
          const index = this.state.headers.findIndex(
            (x) => x.type == TDTypeConsts.EDIT_WITHOUT_HEADER,
          );
          if (index != -1) {
            this.state.headers.splice(index, 1);
          }
        }
        if (!this.state.permissions.editable) {
          const index = this.state.headers.findIndex(
            (x) => x.type == TDTypeConsts.DELETE_WITHOUT_HEADER,
          );
          if (index != -1) {
            this.state.headers.splice(index, 1);
          }
        }
      });
    } else {
      backToHome();
      this.setState({ permissiondenied: true });
    }
  }

  onDelete = (item) => {
    if (get(item, "assignedemployeelist", []).length > 0) {
      this.props.enqueueSnackbar(ErrorMessages.E1210, { variant: "error" });
      return;
    }
    instance
      .delete("exit/exitPolicy", {
        data: {
          exitpolicyid: item.exitpolicyid,
        },
      })
      .then(() => {
        this.props.enqueueSnackbar("Deleted successfully", {
          variant: "success",
        });
        this.getExitPolicies();
      })
      .catch((error) => {
        this.props.enqueueSnackbar(
          error.response ? error.response.data.error.message : error.message,
          { variant: "error" },
        );
      });
  };

  getExitPolicies() {
    const data = {
      offset: 0,
      limit: 100,
    };
    instance.post(`exit/exitpolicies`, data).then((resp) => {
      this.setState({ listdata: resp.data.result, datareceived: true });
    });
  }

  _renderCreate() {
    return (
      <Create
        {...this.props}
        onCreate={true}
        getExitPolicies={this.getExitPolicies}
      />
    );
  }

  _renderEdit() {
    return (
      <Create
        {...this.props}
        editData={this.state.editData}
        onCreate={false}
        currentEditData={this.state.currentEditData}
        getExitPolicies={this.getExitPolicies}
      />
    );
  }

  _onCreate() {
    this.setState({ editData: POST_DATA }, () => {
      this.props.history.push(`${this.props.match.path}/create`);
    });
  }

  onEdit(item) {
    instance.get(`exit/getexitpolicy/${item.exitpolicyid}`).then((result) => {
      if (get(result, "data.result[0]", "")) {
        const resdata = get(result, "data.result[0]", "");
        this.setState({ editData: resdata, currentEditData: resdata }, () => {
          this.props.history.push(`${this.props.match.path}/edit`);
        });
      }
    });
  }

  _renderList() {
    return (
      <div>
        {this.state.listdata.length == 0 ? (
          <CreateComp
            text="Exit policies help define notice periods and provide control over resignation authority for employees. Until an exit policy is assigned for an employee, their separation from the system will not be possible."
            heading="Concept of exit policy"
            onCreate={this._onCreate}
            imageSrc={emptylist}
            permissions={this.state.permissions}
          />
        ) : (
          <List
            onCreate={this._onCreate}
            list={this.state.listdata}
            headers={this.state.headers}
            permissions={this.state.permissions}
            onEdit={this.onEdit}
            onDelete={this.onDelete}
            module="Exit policies"
          />
        )}
      </div>
    );
  }

  render() {
    const { match } = this.props;
    const { datareceived } = this.state;
    return (
      datareceived && (
        <div>
          <Helmet>
            <title>{headersList.Config.ExitPolicy.header}</title>
          </Helmet>
          <IntlProvider locale="en">
            {this.state.permissiondenied ? (
              <div className="position-rel">
                <PermissionDeniedComp />
              </div>
            ) : (
              <div className="content-outer-wrapper">
                <Switch>
                  <Route
                    exact
                    path={`${match.path}`}
                    render={this._renderList}
                  />
                  <Route
                    exact
                    path={`${match.path}/create`}
                    render={this._renderCreate}
                  />
                  <Route
                    exact
                    path={`${match.path}/edit`}
                    render={this._renderEdit}
                  />
                  <Redirect from={`${match.path}`} to={`${match.path}`} />
                </Switch>
              </div>
            )}
          </IntlProvider>
        </div>
      )
    );
  }
}

const mapStateToProps = (state) => ({
  Language: state.LanguageAction.Language,
  SubscriptionInfo: state.SubscriptionInfo,
  loginData: state.AuthenticationAction.login,
  AuthenticationAction: state.AuthenticationAction,
});

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch);

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(withSnackbar(ExitPolicy)),
);

const POST_DATA = {
  exitpolicyid: null,
  policyname: null,
  description: null,
  noticeperioddays: 30,
  isselfresignallowed: null,
  ismanagerresignallowed: null,
  isselfnoticechangeallowed: null,
  ismanagernoticechangeallowed: null,
};
